import './App.css';
import Accordion from './components/Accordion/Accordion';

function App() {
  return (
    <div>
      <Accordion />
    </div>
  );
}

export default App;
